import React from "react";

var Video = function Video() {
  return React.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    d: "M21.3844 11.3625L7.89375 3.1125C7.78018 3.04244 7.64998 3.00396 7.51658 3.00101C7.38318 2.99806 7.25141 3.03075 7.13486 3.09571C7.0183 3.16068 6.92119 3.25556 6.85354 3.37057C6.78589 3.48558 6.75015 3.61656 6.75 3.75V20.25C6.75015 20.3834 6.78589 20.5144 6.85354 20.6294C6.92119 20.7444 7.0183 20.8393 7.13486 20.9043C7.25141 20.9692 7.38318 21.0019 7.51658 20.999C7.64998 20.996 7.78018 20.9576 7.89375 20.8875L21.3844 12.6375C21.4952 12.572 21.5869 12.4787 21.6507 12.367C21.7145 12.2552 21.748 12.1287 21.748 12C21.748 11.8713 21.7145 11.7448 21.6507 11.633C21.5869 11.5212 21.4952 11.428 21.3844 11.3625V11.3625Z",
    stroke: "black",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

export default Video;